module.exports = "build/assets/graph1.1bcf786b.png";